import React, { useState } from 'react';
import axios from '../../../../axios';

const ImportPicklist = () => {
  const [selectedFile, setSelectedFile] = useState(null);

  // Event handler for file selection
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  // Event handler for file upload
  const handleFileUpload = async () => {
    if (!selectedFile) return;

    try {
      // Read the file contents using FileReader API
      const reader = new FileReader();
      reader.onload = async (event) => {
        const fileData = event.target.result;

        // Make the API call to send the file data in the response
        const response = await axios.post('/idesign/exportpicklistinstance', {
          fileData,
          filename: selectedFile.name,
          filetype: selectedFile.type,
        });

        // Handle the API response
        console.log('API response:', response.data);
      };
      reader.readAsDataURL(selectedFile); // You can also use reader.readAsText() or other methods if appropriate

    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };

  return (
    <div>
      <input type="file" onChange={handleFileChange} />
      <button onClick={handleFileUpload}>Upload File</button>
    </div>
  );
};

export default ImportPicklist;
